<template>
  <div :class="visible?'tk-search-tab cur':'tk-search-tab'">
    <div class="main-box">
      <a href="javascript:" class="close" @click="()=>{this.$emit('hideSearch')}"></a>
      <div class="tabs">
        <span :class="tabIndex===1?'cur':''" @click="changeTab(1)">
          <em>文献检索</em>
        </span>
        <span :class="tabIndex===2?'cur':''" @click="changeTab(2)">
          <em>知识检索</em>
        </span>
        <span :class="tabIndex===3?'cur':''" @click="changeTab(3)">
          <em>专业检索</em>
        </span>
        <!-- <span :class="tabIndex===4?'cur':''" @click="changeTab(4)">
          <em>启发式检索</em>
        </span> -->
        <span :class="tabIndex===5?'cur':''" @click="changeTab(5)">
          <em>地图检索</em>
        </span>
      </div>
      <div class="tab-content">
        <book v-if="tabIndex===1" @advancedSearch2="advancedSearch2" :isResultSearch="isResultSearch"/>
        <knowledge v-if="tabIndex===2" @knowledgeChange="knowledgeChange" :isResultSearch="isResultSearch"/>
        <profess v-if="tabIndex===3" @professSearch2="professSearch2" :isResultSearch="isResultSearch"/>
      </div>
    </div>
    <div :class="mapClass">
      <div class="map-main" id="containerTab"></div>
      <div :class="showLeftSearch?'left-search cur':'left-search'">
        <div class="ipt">
          <input id="textSearch" type="text" v-model="freetext" placeholder="在此输入你想查询的条件" style="width: 100%"/>
          <img src="./img/search.png" id="allSearch" style="width: 20px;cursor: pointer;" />
        </div>
        <div class="ipt-r">
          <div class="des cur" v-for="(item,index) in countMarkerList" :key="index">
            <h5 style="font-weight: bolder">
              <img :src="item.path" style="width:20px;margin-right:5px;margin-bottom:2px;"/>
              {{item.label}}<span style="color: #777777">（{{item.count}}）</span>
            </h5>
          </div>
        </div>
        <div class="ctrl">
          <i
            :class="showLeftSearch?'cur':''"
            @click="()=>{this.showLeftSearch=!this.showLeftSearch}"
          ></i>
        </div>
      </div>
      <a href="javascript:" class="full-screen">
        <a-icon type="close" @click="changeTab(1)"></a-icon>
      </a>
      <div class="map-ctrl">
        <a-button class="flc" id="polygonChange" type="primary" size="small">{{tipsChange?'鼠标绘制多边形进行检索':'双击鼠标完成绘制'}}</a-button>
        <a-checkbox class="flc" id="peopleCheck" v-model="peopleMark">
          <img src="./img/people.png"/>人物
        </a-checkbox>
        <a-checkbox class="flc" id="bookCheck" v-model="bookMark">
          <img src="./img/book.png"/>文献
        </a-checkbox>
        <a-checkbox class="flc" id="placeCheck" v-model="placeMark">
          <img src="./img/place.png"/>地点
        </a-checkbox>
        <a-checkbox class="flc" id="actCheck" v-model="actMark">
          <img src="./img/act.png"/>事件
        </a-checkbox>
        <a-checkbox class="flc" id="ogCheck" v-model="ogMark">
          <img src="./img/og.png"/>机构
        </a-checkbox>
      </div>
      <div class="year-choose">
        <div class="years-tb">
          <div v-for="y in 150" class="y-l" :key="y">
            <span v-if="y%10===0">{{1850+y}}</span>
          </div>
        </div>
        <div class="years-tab">
          <div class="left" :style="'width:'+(leftWidth-x)+'px'"></div>
          <div class="tab" id="timeSlide"
            @mousedown="keydown($event)"
            @mouseleave="keyup($event)"
            @mousemove="mousemove($event)"
            @mouseup="keyup($event)"
          ></div>
          <div class="right" :style="'width:'+(rightWidth+x)+'px'"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import book from "./tabs/book";
import knowledge from "./tabs/knowledge";
import profess from "./tabs/profess";

export default {
  props: {
    visible: {
      required: true,
    },
    isResultSearch:{ // 是否列表页检索（result）
        default:false
    },
    navKnowledge:{ // 导航栏知识检索按钮
        default:0
    },
    navAdvanced:{ // 高级检索按钮
        default:0
    },
  },
  data() {
    return {
      freetext: "",
      tipsChange: true,
      tabIndex: 1,
      showLeftSearch: false,
      showSearchResult: false,
      fullscreen: true,
      map: null,
      markers: [],
      overlays: [],
      zoom: 7,
      bookMark: true,
      actMark: true,
      peopleMark: true,
      ogMark: true,
      placeMark: true,
      x: 0,
      cx: 0,
      leftWidth: 0,
      rightWidth: 0,
      cxf: false,
      yearsSelect: [1900, 1950],
      countMarkerList: [],
      count: 0,
      // 框选的坐标
      str: '102.28688478156926%2041.219556269150964,125.18239259406926%2041.136866002737804,122.32594728156926%2028.352231236321252,94.44264650031926%2030.495525800591594', 
      // 页码
      pageth: 1,
    };
  },
  watch: {
    navKnowledge(){
      if(this.navKnowledge) this.tabIndex = 2
    },
    navAdvanced(){
      if(this.navAdvanced) this.tabIndex = 1
    }
  },

  computed: {
    mapClass() {
      if (this.tabIndex === 5 && this.fullscreen) {
        return "map-box cur";
      } else if (this.tabIndex === 5 && !this.fullscreen) {
        return "map-box cur2";
      } else {
        return "map-box";
      }
    },
  },

  components: {
    book,
    knowledge,
    profess,
  },

  mounted() {
    this.mapInit();
  },

  methods: {
    knowledgeChange(data){ // 列表页-知识检索
      this.$emit('knowledgeChange', data);
    },
    professSearch2(data){ // 列表页-专业检索
      this.$emit('professSearch2', data);
    },
    advancedSearch2(data){ // 列表页-高级检索
      this.$emit('advancedSearch2', data);
    },
    mapInit() {
      let that = this
      var cluster, toolBar, scale
      var map = new AMap.Map('containerTab',{
        zoom: 6,
        resizeEnable: true,
        center: [113.778584,34.759197],
      });
      that.map = map
      map.setFeatures(["bg", "road"]); // 展示"区域面","道路"
      AMap.plugin(["AMap.ToolBar", "AMap.Scale", "AMap.OverView", "AMap.MarkerClusterer"],function () {
        cluster = new AMap.MarkerClusterer(map, new AMap.Marker(), {gridSize: 80}); // 点聚合
        toolBar = new AMap.ToolBar({ offset: new AMap.Pixel(document.body.clientWidth-80, 80)}) // 工具条
        map.addControl(toolBar);
        scale = new AMap.Scale(); // 比例尺
        // map.addControl(scale);
      });
      var infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -10) });
      var mouseTool = new AMap.MouseTool(map); //在地图中添加MouseTool插件

      // 跟随页面尺寸变化
      window.onresize = () => {
        map.removeControl(toolBar);
        toolBar = new AMap.ToolBar({ offset: new AMap.Pixel(document.body.clientWidth-80, 80)});
        map.addControl(toolBar);
      };

      // 地图查询方法
      function drawPolygon(map) {
        // ***************************绑定"搜索图标"事件***************************
        AMap.event.addDomListener(document.getElementById("allSearch"), "click", function () {
          find(map)
        });

        // ***************************绑定"搜索回车"事件***************************
        AMap.event.addDomListener(document.getElementById("textSearch"), "keydown", function (e) {
          // 兼容FF和IE和Opera
      　  var theEvent = e || window.event;
      　  var code = theEvent.keyCode || theEvent.which || theEvent.charCode;
      　  if (code == 13) {
            find(map)
          }
        });

        // ***************************绑定"人物-复选框"事件***************************
        AMap.event.addDomListener(document.getElementById("peopleCheck"), "click", function () {
          that.peopleMark = !that.peopleMark
          if(that.count>0) {
            find(map)
          }
        });

        // ***************************绑定"文献-复选框"事件***************************
        AMap.event.addDomListener(document.getElementById("bookCheck"), "click", function () {
          that.bookMark = !that.bookMark
          if(that.count>0) {
            find(map)
          }
        });

        // ***************************绑定"地点-复选框"事件***************************
        AMap.event.addDomListener(document.getElementById("placeCheck"), "click", function () {
          that.placeMark = !that.placeMark
          if(that.count>0) {
            find(map)
          }
        });

        // ***************************绑定"事件-复选框"事件***************************
        AMap.event.addDomListener(document.getElementById("actCheck"), "click", function () {
          that.actMark = !that.actMark
          if(that.count>0) {
            find(map)
          }
        });

        // ***************************绑定"机构-复选框"事件***************************
        AMap.event.addDomListener(document.getElementById("ogCheck"), "click", function () {
          that.ogMark = !that.ogMark
          if(that.count>0) {
            find(map)
          }
        });

        // ***************************绑定"时间拖动-鼠标抬起"事件***************************
        AMap.event.addDomListener(document.getElementById("timeSlide"), "mouseup", function () {
          if(that.count>0) {
            find(map)
          }
        });

        // ***************************绑定"绘制地图"事件***************************
        AMap.event.addDomListener(document.getElementById("polygonChange"), "click", function () {
          // 判断是否需要绘制地图
          if (that.tipsChange) {
            mouseTool.polygon(); //用鼠标工具画多边形
            map.setDefaultCursor("crosshair");
            that.tipsChange = false;
            map.clearMap();
            cluster.clearMarkers();
            that.countMarkerList = []
            that.markers = []
            // 绘制完成双击操作
            var draw = AMap.event.addListener(mouseTool, "draw", function (e) { // 添加事件
              let path = e.obj.getPath(), str = ""; // 获取路径
              // 处理获取的路径数据
              for (let i = 0; i < path.length; i++) {
                str += path[i].R + " " + path[i].Q + ",";
              }
              str = str.substring(0, str.length-1);
              mouseTool.close(true); // 移除鼠标事件
              AMap.event.removeListener(draw); // 移除绘制事件
              that.str = str
              // 获取数据
              achieve(map,cluster)
              that.tipsChange = true;
            });
          } else {
            that.tipsChange = false;
            mouseTool.close(true);
          }
        });
      }

      function find(map) {
        map.clearMap();
        cluster.clearMarkers();
        that.countMarkerList = []
        that.markers = []
        // 获取数据
        achieve(map,cluster)
      }

      // "人物"列表
      function getPersonList(e, mark, map) {
        // 请求地址
        fetch("https://names.library.sh.cn/es/mrPerson/personByPlace?placeUri=" + mark.place + "&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1] +"&pageth=" + that.pageth, {method: "GET"})
          .then((response) => response.json()) // 取数据
          .then((responseText) => { // 处理数据
            // 重新渲染界面
            let genealogyTitle = responseText.data;
            let pageCount = responseText.pager.pageCount;
            let div = $("<div><p style='color:#333;font-size:16px;border-bottom:1px solid #eee;margin-bottom:0.5em;'>" + mark.label + "</p><p style='border-top:1px solid #eee; margin-top:1em; margin-bottom:0;'><a id='prev' style='color:#333;'>上一页</a>---<span style=font-weight:bolder;color:#2D64CD;>" + that.pageth + "/" + pageCount + "</span>---<a id='next' style='color:#333;'>下一页</a></p></div>");
            if (genealogyTitle.length) {
              for (let i = 0; i < genealogyTitle.length; i++) {
                div.find('#prev').parent().before($("<a href='" + genealogyTitle[i].uri + "' target='_blank' style='display:block;font-size:15px;'>" + (genealogyTitle[i].name?genealogyTitle[i].name:"Unknown") + "</a>"));
              }
            } else {
              div.find('#prev').parent().before($("<span style='color: black'>No Data</span>"));
            }
            // 上一页操作
            div.find('#prev').on('click', function(){
              if(that.pageth-1 < 1) {
                that.$message.error("已经是第一页了");
              } else {
                that.pageth = that.pageth-1
                getPersonList(e, mark, map)
              }
            })
            // 下一页操作
            div.find('#next').on('click', function(){
              if(that.pageth+1 > pageCount) {
                that.$message.error("已经是最后页了");
              } else {
                that.pageth = that.pageth+1
                getPersonList(e, mark, map)
              }
            })
            infoWindow.setContent(div[0]);
            infoWindow.open(map, e.target.getPosition());
          })
      }

      // "红色文献"列表
      function getHSWXList(e, mark, map) {
        // 请求地址
        fetch("https://dhapi.library.sh.cn/es/instance/searchByPlace?placeUri=" + mark.place + "&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1] +"&pageth=" + that.pageth, {method: "GET"})
          .then((response) => response.json()) // 取数据
          .then((responseText) => { // 处理数据
            // 重新渲染界面
            let genealogyTitle = responseText.data;
            let pageCount = responseText.pager.pageCount;
            let div = $("<div><p style='color:#333;font-size:16px;border-bottom:1px solid #eee;margin-bottom:0.5em;'>" + mark.label + "</p><p style='border-top:1px solid #eee; margin-top:1em; margin-bottom:0;'><a id='prev' style='color:#333;'>上一页</a>---<span style=font-weight:bolder;color:#2D64CD;>" + that.pageth + "/" + pageCount + "</span>---<a id='next' style='color:#333;'>下一页</a></p></div>");
            if (genealogyTitle.length) {
              for (let i = 0; i < genealogyTitle.length; i++) {
                div.find('#prev').parent().before($("<a href='https://red.library.sh.cn/instanceDetail?data=" + genealogyTitle[i].uri + "' target='_blank' style='display: block;'>" + (genealogyTitle[i].title?genealogyTitle[i].title:"Unknown") + "</a>"));
              }
            } else {
              div.find('#prev').parent().before($("<span style='color: black'>No Data</span>"));
            }
            // 上一页操作
            div.find('#prev').on('click', function(){
              if(that.pageth-1 < 1) {
                that.$message.error("已经是第一页了");
              } else {
                that.pageth = that.pageth-1
                getHSWXList(e, mark, map)
              }
            })
            // 下一页操作
            div.find('#next').on('click', function(){
              if(that.pageth+1 > pageCount) {
                that.$message.error("已经是最后页了");
              } else {
                that.pageth = that.pageth+1
                getHSWXList(e, mark, map)
              }
            })
            infoWindow.setContent(div[0]);
            infoWindow.open(map, e.target.getPosition());
          })
      }

      // "民国图书"列表
      function getMGTSList(e, mark, map) {
        // 请求地址
        fetch("https://jdts.library.sh.cn/mgts/mgts/place?placeUri=" + mark.uri + "&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1] +"&pageth=" + that.pageth, {method: "GET"})
          .then((response) => response.json()) // 取数据
          .then((responseText) => { // 处理数据
            // 重新渲染界面
            let genealogyTitle = responseText.data.resultList;
            let pageCount = responseText.data.pager.pageCount;
            let div = $("<div><p style='color:#333;font-size:16px;border-bottom:1px solid #eee;margin-bottom:0.5em;'>" + mark.label + "</p><p style='border-top:1px solid #eee; margin-top:1em; margin-bottom:0;'><a id='prev' style='color:#333;'>上一页</a>---<span style=font-weight:bolder;color:#2D64CD;>" + that.pageth + "/" + pageCount + "</span>---<a id='next' style='color:#333;'>下一页</a></p></div>");
            if (genealogyTitle.length) {
              for (let i = 0; i < genealogyTitle.length; i++) {
                div.find('#prev').parent().before($("<a href='https://jdts.library.sh.cn/instanceDetail?uri=" + genealogyTitle[i].uri + "' target='_blank' style='display: block;'>" + (genealogyTitle[i].title?genealogyTitle[i].title:"Unknown") + "</a>"));
              }
            } else {
              div.find('#prev').parent().before($("<span style='color: black'>No Data</span>"));
            }
            // 上一页操作
            div.find('#prev').on('click', function(){
              if(that.pageth-1 < 1) {
                that.$message.error("已经是第一页了");
              } else {
                that.pageth = that.pageth-1
                getMGTSList(e, mark, map)
              }
            })
            // 下一页操作
            div.find('#next').on('click', function(){
              if(that.pageth+1 > pageCount) {
                that.$message.error("已经是最后页了");
              } else {
                that.pageth = that.pageth+1
                getMGTSList(e, mark, map)
              }
            })
            infoWindow.setContent(div[0]);
            infoWindow.open(map, e.target.getPosition());
          })
      }

      // "家谱"列表
      function getJPList(e, mark, map) {
        // 请求地址
        fetch("https://dhapi.library.sh.cn/es/jp/webapi/workListByPlace?placeUri=" + mark.place + "&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1] +"&pageth=" + that.pageth, {method: "GET"})
          .then((response) => response.json()) // 取数据
          .then((responseText) => { // 处理数据
            // 重新渲染界面
            let genealogyTitle = responseText.data;
            let pageCount = responseText.pager.pageCount;
            let div = $("<div><p style='color:#333;font-size:16px;border-bottom:1px solid #eee;margin-bottom:0.5em;'>" + mark.label + "</p><p style='border-top:1px solid #eee; margin-top:1em; margin-bottom:0;'><a id='prev' style='color:#333;'>上一页</a>---<span style=font-weight:bolder;color:#2D64CD;>" + that.pageth + "/" + pageCount + "</span>---<a id='next' style='color:#333;'>下一页</a></p></div>");
            if (genealogyTitle.length) {
              for (let i = 0; i < genealogyTitle.length; i++) {
                div.find('#prev').parent().before($("<a href='https://jiapu.library.sh.cn/#/GenealogySummary:" + genealogyTitle[i].work + "' target='_blank' style='display: block;'>" + (genealogyTitle[i].dtitle?genealogyTitle[i].dtitle:"Unknown") + "</a>"));
              }
            } else {
              div.find('#prev').parent().before($("<span style='color: black'>No Data</span>"));
            }
            // 上一页操作
            div.find('#prev').on('click', function(){
              if(that.pageth-1 < 1) {
                that.$message.error("已经是第一页了");
              } else {
                that.pageth = that.pageth-1
                getJPList(e, mark, map)
              }
            })
            // 下一页操作
            div.find('#next').on('click', function(){
              if(that.pageth+1 > pageCount) {
                that.$message.error("已经是最后页了");
              } else {
                that.pageth = that.pageth+1
                getJPList(e, mark, map)
              }
            })
            infoWindow.setContent(div[0]);
            infoWindow.open(map, e.target.getPosition());
          })
      }

      // "事件"列表
      function getEventList(e, mark, map) {
        // 请求地址
        fetch("https://names.library.sh.cn/es/event/searchByPlace?placeUri=" + mark.place + "&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1] +"&pageth=" + that.pageth, {method: "GET"})
          .then((response) => response.json()) // 取数据
          .then((responseText) => { // 处理数据
            // 重新渲染界面
            let genealogyTitle = responseText.data.result;
            let pageCount = responseText.data.pager.pageCount;
            let div = $("<div><p style='color:#333;font-size:16px;border-bottom:1px solid #eee;margin-bottom:0.5em;'>" + mark.label + "</p><p style='border-top:1px solid #eee; margin-top:1em; margin-bottom:0;'><a id='prev' style='color:#333;'>上一页</a>---<span style=font-weight:bolder;color:#2D64CD;>" + that.pageth + "/" + pageCount + "</span>---<a id='next' style='color:#333;'>下一页</a></p></div>");
            if (genealogyTitle.length) {
              for (let i = 0; i < genealogyTitle.length; i++) {
                div.find('#prev').parent().before($("<a href='" + genealogyTitle[i].uri +"' target='_blank' style='display: block;'>" + (genealogyTitle[i].title?genealogyTitle[i].title:"Unknown") + "</a>"));
              }
            } else {
              div.find('#prev').parent().before($("<span style='color: black'>No Data</span>"));
            }
            // 上一页操作
            div.find('#prev').on('click', function(){
              if(that.pageth-1 < 1) {
                that.$message.error("已经是第一页了");
              } else {
                that.pageth = that.pageth-1
                getEventList(e, mark, map)
              }
            })
            // 下一页操作
            div.find('#next').on('click', function(){
              if(that.pageth+1 > pageCount) {
                that.$message.error("已经是最后页了");
              } else {
                that.pageth = that.pageth+1
                getEventList(e, mark, map)
              }
            })
            infoWindow.setContent(div[0]);
            infoWindow.open(map, e.target.getPosition());
          })
      }

      // "机构"列表
      function getOrgList(e, mark, map) {
        // 请求地址
        fetch("https://gj.library.sh.cn/es/api/orgsByPlace?place=" + mark.place + "&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1] +"&pageth=" + that.pageth, {method: "GET"})
          .then((response) => response.json()) // 取数据
          .then((responseText) => { // 处理数据
            // 重新渲染界面
            let genealogyTitle = responseText.orgs;
            let pageCount = responseText.pager.pageCount;
            let div = $("<div><p style='color:#333;font-size:16px;border-bottom:1px solid #eee;margin-bottom:0.5em;'>" + mark.label + "</p><p style='border-top:1px solid #eee; margin-top:1em; margin-bottom:0;'><a id='prev' style='color:#333;'>上一页</a>---<span style=font-weight:bolder;color:#2D64CD;>" + that.pageth + "/" + pageCount + "</span>---<a id='next' style='color:#333;'>下一页</a></p></div>");
            if (genealogyTitle.length) {
              for (let i = 0; i < genealogyTitle.length; i++) {
                div.find('#prev').parent().before($("<a href='" + genealogyTitle[i].uri +"' target='_blank' style='display: block;'>" + (genealogyTitle[i].chsLabel?genealogyTitle[i].chsLabel:"Unknown") + "</a>"));
              }
            } else {
              div.find('#prev').parent().before($("<span style='color: black'>No Data</span>"));
            }
            // 上一页操作
            div.find('#prev').on('click', function(){
              if(that.pageth-1 < 1) {
                that.$message.error("已经是第一页了");
              } else {
                that.pageth = that.pageth-1
                getOrgList(e, mark, map)
              }
            })
            // 下一页操作
            div.find('#next').on('click', function(){
              if(that.pageth+1 > pageCount) {
                that.$message.error("已经是最后页了");
              } else {
                that.pageth = that.pageth+1
                getOrgList(e, mark, map)
              }
            })
            infoWindow.setContent(div[0]);
            infoWindow.open(map, e.target.getPosition());
          })
      }

      async function achieve(map,cluster) {
        that.count += 1
        map.setDefaultCursor("wait");
        // 获取"人物"数据
        if(that.peopleMark) {
          // 总数量查询
          await fetch("https://names.library.sh.cn/es/mrPerson/personCountInArea?points=POLYGON((" + that.str + "))&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1], { method: "GET" })
            .then((response) => response.json()) // 取数据
            .then((responseText) => { // 处理数据
              that.countMarkerList.push({'label':'人物', 'count':Number(responseText.data[0].cnt), 'path':require('@/components/searchTab/img/people.png')})
            })
          // 地图查询
          await fetch("https://names.library.sh.cn/es/mrPerson/personInArea?points=POLYGON((" + that.str + "))&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1], { method: "GET" })
            .then((response) => response.json()) // 取数据
            .then((responseText) => { // 处理数据
              // 重新渲染界面
              let marks = "";
              marks = responseText.data;
              for (let j = 0; j < marks.length; j++) {
                let long, lat;
                long = (Math.random()/100)+parseFloat(marks[j].long);
                lat = (Math.random()/100)+parseFloat(marks[j].lat);
                let marker = new AMap.Marker({
                  position: [long, lat],
                  title: marks[j].label,
                  offset: new AMap.Pixel(10,10), // 设置点标记偏移量
                  content: '<div style="text-align: center;line-height: 1.5"><img src="/pic/people.png" alt="" style="margin: 0 auto;display: block">'+ marks[j].cnt +'</div>',
                });
                that.markers.push(marker);
                //给Marker绑定单击事件
                marker.on("click", function (e) {
                  that.pageth = 1
                  getPersonList(e, marks[j], map)
                });
              }
            })
        }

        // 获取"书目"数据
        if(that.bookMark) {
          let hswx = 0; let mgtu = 0; let jiapu = 0;
          // "红色文献"总数
          await fetch("https://dhapi.library.sh.cn/es/instance/placeInAreaCount?points=POLYGON((" + that.str + "))&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1], { method: "GET" })
            .then((response) => response.json()) // 取数据
            .then((responseText) => { // 处理数据
              hswx = Number(responseText.data[0].cnt)
            })
          // "民国图书"总数
          await fetch("https://jdts.library.sh.cn/mgts/mgts/areaCount?points=POLYGON((" + that.str + "))&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1], { method: "GET" })
            .then((response) => response.json()) // 取数据
            .then((responseText) => { // 处理数据
              mgtu = Number(responseText.data[0].cnt)
            })
          // "家谱"总数
          await fetch("https://dhapi.library.sh.cn/es/jp/webapi/worklistInAreaCount?points=POLYGON((" + that.str + "))&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1], { method: "GET" })
            .then((response) => response.json()) // 取数据
            .then((responseText) => { // 处理数据
              jiapu = Number(responseText.data[0].cnt)
            })
          that.countMarkerList.push({'label':'文献', 'count':hswx+mgtu+jiapu, 'path':require('@/components/searchTab/img/book.png')})

          // 获取"红色文献"数据
          await fetch("https://dhapi.library.sh.cn/es/instance/placeInArea?points=POLYGON((" + that.str + "))&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1], { method: "GET" })
            .then((response) => response.json()) // 取数据
            .then((responseText) => { // 处理数据
              // 重新渲染界面
              let marks = "";
              marks = responseText.data;
              for (let j = 0; j < marks.length; j++) {
                let long, lat;
                long = (Math.random()/100)+parseFloat(marks[j].long);
                lat = (Math.random()/100)+parseFloat(marks[j].lat);
                let marker = new AMap.Marker({
                  position: [long, lat],
                  title: marks[j].label,
                  offset: new AMap.Pixel(-10,-10), // 设置点标记偏移量
                  content: '<div style="text-align: center;line-height: 1.5"><img src="/pic/book.png" alt="" style="margin: 0 auto;display: block">'+ marks[j].cnt +'</div>',
                });
                that.markers.push(marker);
                //给Marker绑定单击事件
                marker.on("click", function (e) {
                  that.pageth = 1
                  getHSWXList(e, marks[j], map)
                });
              }
            })

          // 获取"民国图书"数据
          await fetch("https://jdts.library.sh.cn/mgts/mgts/area?points=POLYGON((" + that.str + "))&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1], { method: "GET" })
            .then((response) => response.json()) // 取数据
            .then((responseText) => { // 处理数据
              // 重新渲染界面
              let marks = "";
              marks = responseText.data;
              for (let j = 0; j < marks.length; j++) {
                let long, lat;
                long = (Math.random()/100)+parseFloat(marks[j].long);
                lat = (Math.random()/100)+parseFloat(marks[j].lat);
                let marker = new AMap.Marker({
                  position: [long, lat],
                  title: marks[j].label,
                  offset: new AMap.Pixel(20,20), // 设置点标记偏移量
                  content: '<div style="text-align: center;line-height: 1.5"><img src="/pic/book.png" alt="" style="margin: 0 auto;display: block">'+ marks[j].cnt +'</div>',
                });
                that.markers.push(marker);
                //给Marker绑定单击事件
                marker.on("click", function (e) {
                  that.pageth = 1
                  getMGTSList(e, marks[j], map)
                });
              }
            })

          // 获取"家谱"数据
          await fetch("https://dhapi.library.sh.cn/es/jp/webapi/worklistInArea?points=POLYGON((" + that.str + "))&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1], { method: "GET" })
            .then((response) => response.json()) // 取数据
            .then((responseText) => { // 处理数据
              // 重新渲染界面
              let marks = "";
              marks = responseText.data;
              for (let j = 0; j < marks.length; j++) {
                let long, lat;
                long = (Math.random()/100)+parseFloat(marks[j].long);
                lat = (Math.random()/100)+parseFloat(marks[j].lat);
                let marker = new AMap.Marker({
                  position: [long, lat],
                  title: marks[j].label,
                  offset: new AMap.Pixel(-20,-20), // 设置点标记偏移量
                  content: '<div style="text-align: center;line-height: 1.5"><img src="/pic/book.png" alt="" style="margin: 0 auto;display: block">'+ marks[j].cnt +'</div>',
                });
                that.markers.push(marker);
                //给Marker绑定单击事件
                marker.on("click", function (e) {
                  that.pageth = 1
                  getJPList(e, marks[j], map)
                });
              }
            })
        }

        // 获取"地点"数据
        if(that.placeMark) {
          // 总数量查询
          await fetch("https://gj.library.sh.cn/es/api/common/placeCountInArea?points=POLYGON((" + that.str + "))&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1], { method: "GET" })
            .then((response) => response.json()) // 取数据
            .then((responseText) => { // 处理数据
              that.countMarkerList.push({'label':'地点', 'count':Number(responseText.data[0].cnt), 'path':require('@/components/searchTab/img/place.png')})
            })
          // 地图查询
          await fetch("https://gj.library.sh.cn/es/api/common/placeInArea?points=POLYGON((" + that.str + "))&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1], { method: "GET" })
            .then((response) => response.json()) // 取数据
            .then((responseText) => { // 处理数据
              // 重新渲染界面
              let marks = "";
              marks = responseText.data;
              for (let j = 0; j < marks.length; j++) {
                let long, lat;
                long = (Math.random()/100)+parseFloat(marks[j].long);
                lat = (Math.random()/100)+parseFloat(marks[j].lat);
                let marker = new AMap.Marker({
                  position: [long, lat],
                  title: marks[j].label,
                  offset: new AMap.Pixel(30,30), // 设置点标记偏移量
                  content: "<a href='" + marks[j].place + "' target='_blank'><div style='text-align: center;line-height: 1.5'><img src='/pic/place.png' alt='' style='margin: 0 auto;display: block'>" + marks[j].label + "</div></a>",
                });
                that.markers.push(marker);
              }
            })
        }

        // // 获取"事件"数据
        if(that.actMark) {
          // 总数量查询
          await fetch("https://names.library.sh.cn/es/event/placeInAreaCount?points=POLYGON((" + that.str + "))&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1], { method: "GET" })
            .then((response) => response.json()) // 取数据
            .then((responseText) => { // 处理数据
              that.countMarkerList.push({'label':'事件', 'count':Number(responseText.data[0].cnt), 'path':require('@/components/searchTab/img/act.png')})
            })
          // 地图查询
          await fetch("https://names.library.sh.cn/es/event/eventInArea?points=POLYGON((" + that.str + "))&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1], { method: "GET" })
            .then((response) => response.json()) // 取数据
            .then((responseText) => { // 处理数据
              // 重新渲染界面
              let marks = "";
              marks = responseText.data;
              for (let j = 0; j < marks.length; j++) {
                let long, lat;
                long = (Math.random()/100)+parseFloat(marks[j].long);
                lat = (Math.random()/100)+parseFloat(marks[j].lat);
                let marker = new AMap.Marker({
                  position: [long, lat],
                  title: marks[j].label,
                  offset: new AMap.Pixel(30,30), // 设置点标记偏移量
                  content: '<div style="text-align: center;line-height: 1.5"><img src="/pic/act.png" alt="" style="margin: 0 auto;display: block">'+ marks[j].cnt +'</div>',
                });
                that.markers.push(marker);
                //给Marker绑定单击事件
                marker.on("click", function (e) {
                  that.pageth = 1
                  getEventList(e, marks[j], map)
                });
              }
            })

        }

        // 获取"机构"数据
        if(that.ogMark) {
          // 总数量查询
          await fetch("https://gj.library.sh.cn/es/api/orgCountInArea?points=POLYGON((" + that.str + "))&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1], { method: "GET" })
            .then((response) => response.json()) // 取数据
            .then((responseText) => { // 处理数据
              that.countMarkerList.push({'label':'机构', 'count':Number(responseText.data[0].cnt), 'path':require('@/components/searchTab/img/og.png')})
            })
          // 地图查询
          await fetch("https://gj.library.sh.cn/es/api/orgInArea?points=POLYGON((" + that.str + "))&freetext=" + that.freetext + "&startYear=" + that.yearsSelect[0] + "&endYear=" + that.yearsSelect[1], { method: "GET" })
            .then((response) => response.json()) // 取数据
            .then((responseText) => { // 处理数据
              // 重新渲染界面
              let marks = "";
              marks = responseText.data;
              for (let j = 0; j < marks.length; j++) {
                let long, lat;
                long = (Math.random()/100)+parseFloat(marks[j].long);
                lat = (Math.random()/100)+parseFloat(marks[j].lat);
                let marker = new AMap.Marker({
                  position: [long, lat],
                  title: marks[j].label,
                  offset: new AMap.Pixel(-30,-30), // 设置点标记偏移量
                  content: '<div style="text-align: center;line-height: 1.5"><img src="/pic/og.png" alt="" style="margin: 0 auto;display: block">'+ marks[j].cnt +'</div>',
                });
                that.markers.push(marker);
                //给Marker绑定单击事件
                marker.on("click", function (e) {
                  that.pageth = 1
                  getOrgList(e, marks[j], map)
                });
              }
            })
        }
        cluster.setMarkers(that.markers);
        map.setDefaultCursor("default");
      }

      drawPolygon(map);
      that.initSize();
    },

    changeTab(index) {
      this.tabIndex = index;
      // 向父组件（book.vue）传值
      this.$emit('getTabIndex', this.tabIndex);
      // 地图检索时，隐藏滚动条
      if(this.tabIndex===5) {
        document.body.parentNode.style.overflowY = "hidden";
      } else {
        document.body.parentNode.style.overflowY = "auto";
      }
    },

    keyup() {
      if (!this.cxf) {
        return;
      }
      this.cx = 0;
      this.cxf = false;
      this.leftWidth = this.leftWidth - this.x;
      this.rightWidth = this.rightWidth + this.x;
      this.x = 0;
      const y = Math.floor(
        150 * (this.leftWidth / (document.body.clientWidth * 0.98))
      );
      this.yearsSelect = [1850 + y, 1850 + y + 50];
    },

    mousemove(e) {
      if (!this.cxf) {
        return;
      }
      this.x = this.cx - e.clientX;
    },

    keydown(e) {
      this.cxf = true;
      this.cx = e.clientX;
    },

    initSize() {
      const fw = (document.body.clientWidth * 0.98) / 3;
      this.leftWidth = fw;
      this.rightWidth = fw;
    },
  },
};
</script>
